import './events.css';
import {
    EventRoleWithMemberships,
    fetchEventsWithMembership,
    fetchPublicEvents,
} from '@modules/supabase/events';
import FAB from '@atoms/FAB';
import useAuth from '@hooks/useAuth';
import useModalControl from '@hooks/useModalControl';
import { Column } from '@material-table/core';
import EventsList from './EventsList';
import { RegistrationStatusColumn } from '@atoms/RegistrationStatusColumn';

export default function Events() {
    const { authUser } = useAuth();
    const { setShowEventModal } = useModalControl();

    const fetchEvents = authUser?.id ? fetchEventsWithMembership : fetchPublicEvents;

    return (
        <>
            <EventsList fetchEvents={fetchEvents} columns={COLUMNS} />
            <FAB onClick={() => setShowEventModal(true)} toolTip="Add event" />
        </>
    );
}

const COLUMNS: Column<EventRoleWithMemberships>[] = [RegistrationStatusColumn];
